import { render } from "./DefPrice.vue?vue&type=template&id=d6b3cd8a&scoped=true"
import script from "./DefPrice.vue?vue&type=script&lang=js"
export * from "./DefPrice.vue?vue&type=script&lang=js"

import "./DefPrice.vue?vue&type=style&index=0&id=d6b3cd8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b3cd8a"]])

export default __exports__